import {
  LOAD_CONTACT_INFO_SUCCESS,
  LOAD_CONTACT_INFO_ERROR,
  LOAD_CONTACT_INFO_START,
  CONTACT_INFO_LOAD_ADDRESS_INFO,
  CONTACT_INFO_LOAD_COMPANY_LOGO,
  CONTACT_INFO_UPDATE_ADDRESS_INFO,
  CONTACT_INFO_SHOW_ADDRESS_VALIDATION_ERRORS,
  CONTACT_INFO_RESET_PAGE,
  CONTACT_INFO_SUBMIT,
  CONTACT_INFO_SUBMIT_START,
  CONTACT_INFO_RESET_ADDRESS_VALIDATION_ERRORS,
  CONTACT_INFO_SUBMIT_COMPLETE,
  CONTACT_INFO_SUBMIT_ERROR,
  CONTACT_INFO_SUBMIT_RESET,
  CONTACT_INFO_UPDATE_ADDRESS_INFO_FIELDS,
}
  from 'constants/ActionTypes';

export const loadContactInfoStart = () => ({ type: LOAD_CONTACT_INFO_START });
export const loadContactInfoSuccess = () => ({ type: LOAD_CONTACT_INFO_SUCCESS });
export const loadContactInfoError = () => ({ type: LOAD_CONTACT_INFO_ERROR });
export const loadContactAddressInfo = (addressInfo) => ({ type: CONTACT_INFO_LOAD_ADDRESS_INFO, addressInfo });
export const loadContactInfoLogo = (companyLogo) => ({ type: CONTACT_INFO_LOAD_COMPANY_LOGO, companyLogo });
export const updateContactAddressInfo = (fieldId, value) => ({ type: CONTACT_INFO_UPDATE_ADDRESS_INFO, fieldId, value });
export const updateContactAddressValidationErrorsForDisplay = () => ({ type: CONTACT_INFO_SHOW_ADDRESS_VALIDATION_ERRORS });
export const resetContactInfoPage = () => ({ type: CONTACT_INFO_RESET_PAGE });
export const submitContactInfo = () => ({ type: CONTACT_INFO_SUBMIT });
export const submitContactInfoStart = () => ({ type: CONTACT_INFO_SUBMIT_START });
export const submitContactInfoComplete = () => ({ type: CONTACT_INFO_SUBMIT_COMPLETE });
export const submitContactInfoError = (errorMessage) => ({ type: CONTACT_INFO_SUBMIT_ERROR, errorMessage });
export const resetBillingSubmission = () => ({ type: CONTACT_INFO_SUBMIT_RESET });
export const updateContactAddressInfoFields = (addressInfo) => ({ type: CONTACT_INFO_UPDATE_ADDRESS_INFO_FIELDS, addressInfo });
export const submitContactInfoValidationError = (validationError) => ({ type: CONTACT_INFO_SHOW_ADDRESS_VALIDATION_ERRORS, validationError });
export const resetContactInfoValidationError = () => ({ type: CONTACT_INFO_RESET_ADDRESS_VALIDATION_ERRORS });
